<div class="dialog-wrapper">
  <bms-common-title-section
    [icon]="icon"
    [title]="title"
    [subTitle]="subTitle"
  ></bms-common-title-section>

  <div class="dialog-scrollable-content">
    <ng-content></ng-content>
  </div>

  <bms-common-popup-footer
    *ngIf="!hideFooter"
    [cancelTitle]="cancelTitle"
    [submitTitle]="submitTitle"
    [secondarySubmitTitle]="secondarySubmitTitle"
    [isCancelEnabled]="isCancelEnabled"
    [isSubmitEnabled]="isSubmitEnabled"
    [isSecondarySubmitEnabled]="isSecondarySubmitEnabled"
    (onCancelClick)="onClickCancel($event)"
    (onSubmitClick)="onClickSubmit($event)"
    (onSecondarySubmitClick)="onClickSecondarySubmit($event)"
  >
  </bms-common-popup-footer>
</div>
